import {mapState} from 'vuex'
import accountService from '../../services/account-service'
import Header from '../Header/Header.vue'
import Nav from '../Nav/Nav.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'Contact',
    components: {
        Header,
        Nav
    },
    data() {
        return {
            subject: '',
            comment: '',
            browser: '',
        }
    },
    methods: {
        sendComment() {
            accountService.sendComment(this.subject, this.browser, this.comment, this.user.email)
            this.$gtag.event('send-comment-click', {
                'event_category': 'comments',
                'event_label': 'Send Comment',
                'value': this.comment
            })
        }
    },
    computed: {
        ...mapState({
            user: state => state.account.user
        }),
    },
    validations: {
        subject: {
        required
        },
        comment: {
        required
        }
    },
    created() {
        this.$store.dispatch('account/getUser');
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Contact',
        })
    }
}